import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import L from "leaflet"
import styled from "styled-components"
import { GestureHandling as gestureHandling } from "leaflet-gesture-handling"
import { MapContainer, TileLayer, useMapEvents } from "react-leaflet"
import Marker from "./Marker"

import Actions from "../../redux/actions"

const Map = styled(MapContainer)`
  width: 100%;
  height: 100%;
  position: relative;

  path.leaflet-interactive {
    display: none !important;
  }

  .leaflet-marker-icon{
    border-radius: 100%;
    border: 1px solid #000;
  }
`

export default function FComponentMapIndex(props) {

  const dispatch = useDispatch()

  function LocationMarker() {
    const map = useMapEvents({
      click(e) {
        map.locate()
        dispatch(Actions.MgtStation.setCurrentLocation({lat: parseFloat(e.latlng.lat.toFixed(6)), lng: parseFloat(e.latlng.lng.toFixed(6))}))
        map.flyTo(e.latlng, map.getZoom())
      }
    })
  
    return !props.location ? null : (
      <Marker position={props.location} noDesc>
      </Marker>
    )
  }

  const fetchMarker = (props.data ? props.data : []).map((item, index) => {
    return (
        <Marker key={item.id ? item.id : index} {...item} sensorType={props.sensorType} noDesc={props.noDesc ? props.noDesc : ''}/>
    )
  })

  return (
    <Map key={"map"} center={props.center ? props.center : [10.726316, 100.591507]} zoom={props.zoom ? props.zoom : 6} gestureHandling={true}>
      <TileLayer key={'tile-layer'}
        attribution='&copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {props.data ? fetchMarker : ''}
      {props.mode == "location" ?  <LocationMarker/> : ''}
    </Map>
  )
}
